import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgModel } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationSetupCommon } from 'src/app/organization-setup/organization-setup.common';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';

@Component({
  selector: 'app-mis-report',
  templateUrl: './mis-report.component.html',
  styleUrls: ['./mis-report.component.css']
})
export class MisReportComponent implements OnInit {

  financialList;
  partnerList;
  selectedFinancialYear=null;
  selectedQuarter=[];
  selectedPartner=[];
  isQuarterSelected=false;
  isPartnerSelected=false;
 

  constructor( private modalService: NgbModal,
    private fb: FormBuilder,
    private humanResourceService: HumanResourceService,
    private diaryReportService: DiaryReportService,
    private organizationService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private commonMessageService:CommonMessageService,) { }

    QuarterList=[{id:1,name:"Quarter1"},{id:2,name:"Quarter2"},{id:3,name:"Quarter3"},{id:4,name:"Quarter4"}];

  ngOnInit(): void {
    this.loadFYDetails();
    this.loadPartnerDetails();
  }

  loadFYDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  loadPartnerDetails(){
    this.masterDataService.getPartners().subscribe((res) => {
      this.partnerList = res;
      console.log('Partner list', this.partnerList);
    })
  }

  onFYSelected() {
    // this.reportList=undefined;
    // this.showExcelButton=false;
    // this.selectPartner="";
    //   this.getAllPartnerDetails();
    console.log(this.selectedFinancialYear);
    //this.getAllClientDetails();
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  // selectAllAssignment(select: NgModel, values){
  //   this.selectAll(select, values, this.isAssignmentSelected);
  //   this.isAssignmentSelected = !this.isAssignmentSelected;
  // }

  selectAllQuarter(select: NgModel, values){
    this.selectAll(select, values, this.isQuarterSelected);
    this.isQuarterSelected = !this.isQuarterSelected;
  }

  selectAllPartner(select: NgModel, values){
    this.selectAll(select, values, this.isPartnerSelected);
    this.isPartnerSelected = !this.isPartnerSelected;
  }

  exportToExcelClick(){


     const partner = this.selectedPartner.map(({ id }) => id);
     const quarter = this.selectedQuarter.map(({ name }) => name);
    // const quarterId = this.selectedQuarter.map(({ id }) => id);
    if(this.selectedFinancialYear!=null && this.selectedQuarter.length>0 && this.selectedPartner.length>0 )
   { 
    
        this.organizationService.getMisReportDetailsAPI(partner,this.selectedFinancialYear.id,quarter).subscribe(
    
      (resp:any) => {
        console.log("mis response check:",resp)
        if(resp.size>2)
        {
          console.log("response:",resp)
          const blob = new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var downloadURL= window.URL.createObjectURL(blob);
        console.log('Blob size:', blob.size);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "MIS_Report.xlsx";
        link.click();
      }
      else
      {
        this.commonMessageService.swalAlertWithoutIcon('','No records found!.');
      }
      });
    }
    else{
      this.commonMessageService.swalAlertWithoutIcon('','Please select mandatory fields.');
    }   
  }
  
}
